import { FeaturedLink, ImageType } from '../../types/featured-link'

export function getImage(
  item: any
): [url: string | undefined, imageType: ImageType] {
  const { heroImageSet } = item

  if (heroImageSet === null || heroImageSet === undefined) {
    return [undefined, ImageType.none]
  } else if (heroImageSet.square && heroImageSet.square.url) {
    return [heroImageSet.square.url, ImageType.square]
  } else if (heroImageSet.master && heroImageSet.master.url) {
    return [heroImageSet.master.url, ImageType.master]
  } else {
    return ['', ImageType.none]
  }
}

export function graphqlToFeaturedLink(item: any): FeaturedLink {
  const [imageUrl, imageType] = getImage(item)
  return {
    imageType,
    imageUrl,
    title: item.title,
    url: item.url || '',
    shortDescription: item.shortDescription,
    callToActionLabel: item.callToActionLabel,
  }
}
